import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CurrencyCardIcon from '../utils/currency-card-icon.js';



class BountyCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		let title = '';
		let wanted = '';
		let amount = 0;
		let number_rewards = 1;
		let currency = {symbol: ''};
		let currencies= [];
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		
		this.closing = false;
		
		this.state = {
			title,
			wanted,
			amount,
			currency,
			currencies,
			number_rewards,
			private_submission: false,
			one_submission: false,
			signingkey,
			currentcard,
			balance,
			message_text: '',
			processinginfo: 'processing submission',
			processing: false
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		//console.log('BountyCreateForm.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// limit the size of wanted to 512
		if (this.state.wanted != prevState.wanted) {
			if (this.state.wanted.length > 512) {
				let wanted = this.state.wanted.slice(0,512);

				this._setState({wanted});
			}
		}

		// limit number of rewards to 100
		if (this.state.number_rewards != prevState.number_rewards) {
			if (this.state.number_rewards > 100) {
				let number_rewards = 100;

				this._setState({number_rewards});
			}
		}

		// entered a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, {maincard: true})
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this._setState({currentcard, balance});
				})
				.catch(err => {
					this._setState({currentcard, balance})
				});
			}
		}

		// selected a currency
		if (this.state.currency && this.state.currency.uuid && (this.state.currency.uuid != (prevState.currency ? prevState.currency.uuid : null))) {
			// we reset the current card
			let currentcard = null;
			let balance = '';

			const currency = this.state.currency;
			let currencyuuid = currency.uuid;

			this.app.openCurrencyCard(currencyuuid)
			.then(card => {
				if (!card)
					throw 'no current card';

				currentcard = card;

				return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			})
			.then((pos) => {
				return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
			})
			.then((balance) => {
				this._setState({currentcard, balance});
			})			
			.catch(err => {
				this._setState({currentcard, balance})
			});

		}
	}

	componentDidMount() {
		console.log('BountyCreateForm.componentDidMount called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();
		
		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		// list of currencies
		this.mvcmyquote.getCurrencies(rootsessionuuid, walletuuid)
		.then((currencies) => {
			this._setState({currencies});
		})
		.catch(err => {
			console.log('error in BountyCreateForm.componentDidMount ' + err);
		});


		// message translated in user's language
		let message_text = mvcmyquote.t(
		'When you press the button \'Create Bounty\', a url will be generated that you will \
		be able to publish on the web or send via email. \
		If you haven\'t yet provided your private key for the corresponding currency, \
		you will be asked to enter it at the next step so that your bounty is signed \
		and a new card is created to safeguard funds and distribute rewards. \
		Your private key will be crypted and stored on your device, it will not leave \
		your device at any time and will not be shared with anyone. \
		Your bounty offer will then be registered and be accessible to anyone clicking on \
		the link that has been generated. \
		Anyone will then be able to place their claims and receive their reward if you \
		accept them, you can also reject claims.');

		this._setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;

 		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		 .catch(err => {
		 });

		 if (!unlocked) {
			let params = (app_nav_target ? app_nav_target.params : null);
			this.app.gotoRoute('login', params);
			return;
		 }
		 else {
			// check it is not the device wallet, because we need a safer wallet
			let isdevicewallet = await this.app.isDeviceWallet();
			
			if (isdevicewallet) {
				await this.app.resetWallet();
				
			   let params = (app_nav_target ? app_nav_target.params : null);
			   this.app.gotoRoute('login', params);
			   return;
			 }
	   }

		 if (app_nav_target && (app_nav_target.route == 'bounty') && (app_nav_target.reached == false)) {
		}

	 }

	// end of life
	componentWillUnmount() {
		console.log('BountyCreateForm.componentWillUnmount called');
		
		this.closing = true;
	}

	
	// user actions
	
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let wallet;
		let carduuid;
		let card;
		
		let { title, wanted, amount, currency, number_rewards, private_submission, one_submission, currentcard, signingkey } = this.state;

		this._setState({processing: true});

		try {
			if (!title || (title.length == 0)) {
				this.app.alert('You need to enter a title');
				this._setState({processing: false});
				return;
			}
	
	
			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this._setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, {maincard: true})
					.catch(err => {
						console.log('error in BountyCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('Could not create card from private key');
						this._setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' in order to sign and fund your bounty');
					this._setState({processing: false});
					return;
				}
		
			}

			// check card can transfer credit units and tokens
			let _privkey = await  mvcmyquote.getCardPrivateKey(rootsessionuuid, walletuuid, card.uuid).catch(err => {});
			let cansign = (_privkey ? true : false);

			if (cansign !== true) {
				this.app.alert('Current card for the currency is read-only');
				this._setState({processing: false});
				return;
			}

			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in BountyCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the bounty');
				this._setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in BountyCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register bounty. Wait a few seconds and try again.');
				this._setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this._setState({processing: false});
					return;
				}
			} 

			// we check that the main card has enough credits to send tokens AND credits to the bounty card
			let txinfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, card.schemeuuid);
			let units_threshold = txinfo.units_threshold;
			let units_per_token_transfer = 3;
			let units_needed = parseInt(number_rewards) * units_per_token_transfer + units_threshold + 1;

			let credits_needed = await mvcmyquote.getCreditsFromUnits(rootsessionuuid, card.schemeuuid, units_needed)

			if (currency.ops.cantopup !== true) {
				let credits = await mvcmyquote.getCreditBalance(rootsessionuuid, walletuuid, carduuid);
				let credits_balance_required = credits.threshold + credits_needed;

				if ((credits.transactioncredits < credits_balance_required)) {
					let units_balance_required = await mvcmyquote.getUnitsFromCredits(rootsessionuuid, card.schemeuuid, credits_balance_required);
					this.app.alert('you don\'t have enough transaction credits to fund the bounty card. You need at least ' + units_balance_required + ' units');
					this.setState({processing: false});
					return;
				}
			}
			else {
				// we top-up the main card to be sure being able to send funds to bounty card
				const topupinfo_main = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, carduuid)		
				.catch(err => {
					console.log('error in BountyCreateForm.onSubmit: ' + err);
				});
		
				if ((!topupinfo_main) || (!topupinfo_main.top) ) {
					this.app.alert('Could not top up account to fund bounty card. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
				else {
					let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, card.schemeuuid);
					let credits_balance_required = transactioninfo.credits_threshold + credits_needed;
					if (topupinfo_main.balance <= credits_balance_required) {
						let units_balance_required = await mvcmyquote.getUnitsFromCredits(rootsessionuuid, card.schemeuuid, credits_balance_required);
						this.app.alert('Top-up can not provide ' + units_balance_required + '  units. You will need to transfer credit units manually to your main card.');
						this.setState({processing: false});
						return;
					}
				} 

			}	

	
			// we create a card to hold funds for the bounty
			console.log('creating bounty card to hold funds');
			let bountycard = await mvcmyquote.generateCurrencyCard(rootsessionuuid, walletuuid, currency.uuid)		
			.catch(err => {
				console.log('error in BountyCreateForm.onSubmit: ' + err);
			});
	
			if (!bountycard) {
				this.app.alert('Could not create a card to hold funds for the bounty');
				this._setState({processing: false});
				return;
			}

			console.log('created bounty card with address ' + bountycard.address);

	
			let bounty_card_address = bountycard.address;
			let bounty_card_private_key = await mvcmyquote.getCardPrivateKey(rootsessionuuid, walletuuid, bountycard.uuid);
			let bounty_card_private_key_encrypted = await mvcmyquote.aesEncryptString(rootsessionuuid, walletuuid, card.uuid, bounty_card_private_key);
	
			// send transaction registering bounty
			let owner_address = pretradecard.address;
			let owner_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
			let bounty = {type: 'bounty', title, wanted, 
							bounty_card_address, bounty_card_private_key_encrypted,
							amount, currency: currency.symbol, currencyuuid: currency.uuid,
							number_rewards, private_submission, one_submission,
							owner: owner_address, owner_rsa_publickey};
			let assignto = owner_address;

			console.log('registering bounty in pretrade');
	
			let bounty_txhash = await mvcmyquote.registerBounty(rootsessionuuid, walletuuid, pretradecard.uuid, bounty)
			.catch(err => {
				console.log('error in BountyCreateForm.onSubmit: ' + err);
			});
	
			if (!bounty_txhash) {
				this.app.alert('Could not register the bounty');
				this._setState({processing: false});
				return;
			}
			
			console.log('bounty registration hash is ' + bounty_txhash);
	
	


			// transfer transaction units from main card to the bounty card
			console.log('transfering transaction units to bounty card ' + units_needed);

			let units_txhash = await mvcmyquote.transferTransactionUnits(rootsessionuuid, walletuuid, currentcard.uuid, bountycard.uuid, units_needed);
			
			if (!units_txhash) {
				this.app.alert('Could not transfer transaction units to bounty card');
				this._setState({processing: false});
				return;
			}

			console.log('transaction units transfer hash is ' + units_txhash);

			
			// transfer tokens from main card to the bounty card
			let token_amount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currency.uuid, amount);
			await token_amount.multiply(parseInt(number_rewards));
			let token_amount_string = await token_amount.toString();
	
			console.log('transfering token amount to bounty card ' + token_amount_string);

			let tokens_txhash = await mvcmyquote.transferCurrencyAmount(rootsessionuuid, walletuuid, currentcard.uuid, bountycard.uuid, currency.uuid, token_amount);
	
			if (!tokens_txhash) {
				this.app.alert('Could not transfer tokens to bounty card');
				this._setState({processing: false});
				return;
			}

			console.log('token transfer hash is ' + tokens_txhash);

			

			// get share link
			var bountyurl = await this.app.getShareLink(bounty_txhash, currency.uuid);
	
			//this.app.alert('Send url ' + bountyurl);
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash: bounty_txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('bounties', params);
	
			this._setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.app.error('exception in onSubmit: ' + e);

			this.app.alert('could not create bounty')

			this._setState({processing: false});
		}
	}

	async onChangeCurrency(e) {
		var cur = e.target.value;

		var {currencies} = this.state;
		var currency;

		for (var i = 0; i < currencies.length; i++) {
			if (cur === currencies[i].symbol) {
				currency = currencies[i];
				break;
			}
		}

		if (currency) {
			this._setState({currency});
		}
	}

	async onSelectCurrency(uuid) {
		var {currencies} = this.state;
		var currency;

		for (var i = 0; i < currencies.length; i++) {
			if (uuid === currencies[i].uuid) {
				currency = currencies[i];
				break;
			}
		}

		if (currency)
		this._setState({currency});
	}

	async onShowCurrencyCard() {
		let currency = this.state.currency;
		let params = {currencyuuid: currency.uuid};
		this.app.gotoRoute('currencycard', params);
	}

	
	// rendering
	renderMainCardPart() {
		let { currency, currentcard, signingkey, balance } = this.state;

		return (
			<span>
				{(currentcard ?
					<FormGroup className="CurrencyCard" controlId="address">
					<span className="CardIconCol">
						<CurrencyCardIcon
							app={this.app}
							currency={currency}
							card={currentcard}
						/>
					</span>
					<span className="CardBalanceCol">
						<FormLabel>Balance</FormLabel>
						<FormControl
							className="CardBalanceCol"
							disabled
							autoFocus
							type="text"
							value={balance}
						/>
					</span>
					</FormGroup> :
					<FormGroup controlId="signingkey">
						<FormLabel>Private key {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
						<FormControl
						autoFocus
						type="text"
						value={(signingkey ? signingkey : '')}
						onChange={e => this._setState({signingkey: e.target.value})}
						/>
					</FormGroup>
				)}		
			</span>
		);

	}

	renderBountyCreateForm() {
		let { title, wanted, amount, number_rewards, private_submission, one_submission, currencies, currency, currentcard, signingkey, balance, message_text } = this.state;
		
		return (
			<div className="Form">
			  <div>
				<FormGroup controlId="title">
				  <FormLabel>Bounty Title</FormLabel>
				  <FormControl
					autoFocus
					type="text"
					value={title}
					onChange={e => this._setState({title: e.target.value})}
				  />
				</FormGroup>

				<FormGroup controlId="wanted">
				  <FormLabel>Wanted</FormLabel>
				  <FormControl 
					as="textarea" 
					rows="3" 
					autoFocus
					type="text"
					value={wanted}
					onChange={e => this._setState({wanted: e.target.value})}
				  />
				</FormGroup>
				
				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Reward</FormLabel>
				<FormControl 
					autoFocus
					type="text"
					value={amount}
					onChange={e => this._setState({amount: e.target.value})}
				  />
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
					<DropdownButton
						id="input-dropdown-addon"
						title="Cur."
						onSelect={e => this.onSelectCurrency(e)}
					>
						{currencies.map((item, index) => (
							<Dropdown.Item key={item.uuid} eventKey={item.uuid} value={item.uuid}>{item.symbol}</Dropdown.Item>
						))}
					</DropdownButton>
				</InputGroup>
				 </span>
				</FormGroup>

				<FormGroup className="Bounty" controlId="bounty">
				<span className="BountyNumberCol">
				<FormLabel>Number of rewards</FormLabel>
				<FormControl
					autoFocus
					type="text"
					value={number_rewards}
					onChange={e => this._setState({number_rewards: e.target.value})}
				  />
				</span>
				<span className="BountyAnswerCheckCol">
				<FormLabel>Answer</FormLabel>
				<InputGroup className="BountyAnswerCheckboxLine">
					<InputGroup.Checkbox className="BountyAnswerCheckboxCheck"
							aria-label="Answer kept private"
							checked={private_submission}
							onChange={e => this._setState({private_submission: e.target.checked})}
					/>
					<FormLabel className="BountyAnswerCheckboxLabel">Answer kept private</FormLabel>
				</InputGroup>
				<InputGroup className="BountyAnswerCheckboxLine">
					<InputGroup.Checkbox className="BountyAnswerCheckboxCheck"
							aria-label="One answer"
							checked={one_submission}
							onChange={e => this.setState({one_submission: e.target.checked})}
					/>
					<FormLabel className="BountyAnswerCheckboxLabel">One answer only</FormLabel>
				</InputGroup>
				</span>
				</FormGroup>
				
				{this.renderMainCardPart()}
				
				<Button 
				disabled={(currentcard ? false : true)}
				onClick={this.onSubmit.bind(this)} 
				type="submit">
				  Create Bounty
				</Button>

				<div className="TextBox">
				  {message_text}
			  	</div>

			  </div>
			</div>
		  );
	}

	renderItem(item){
		let type = item.type;
		let label = item.label;

		return (
			<div>
				<span>{(type == 0 ? <FontAwesomeIcon icon={faMobileAlt} /> : <FontAwesomeIcon icon={faGlobe} />)}</span>
				<span>{label}</span>
			</div>
		);
	}
	

	render() {
		let {processing} = this.state; 
		
		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Bounty</div>
				{ this.renderBountyCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
BountyCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		currentcarduuid: state.cards.carduuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {BountyCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(BountyCreateForm);

